import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

export function ReturnHeader({
    backLink,
    className,
}: {
    backLink?: {
        label: string;
        onClick: () => void;
    };
    className?: string;
}) {
    return (
        <div
            className={clsx(
                "flex items-center py-1",
                "justify-between",
                className,
            )}
        >
            {backLink && (
                <div
                    className="group flex cursor-pointer items-center gap-2"
                    onClick={backLink.onClick}
                >
                    <ChevronLeftIcon
                        width={12}
                        height={12}
                        className={clsx(
                            "text-gray-400 transition-opacity duration-200",
                            "sm:opacity-0 sm:group-hover:opacity-100",
                        )}
                    />
                    <span className="ui-element subdued cursor-pointer">
                        {backLink.label}
                    </span>
                </div>
            )}
        </div>
    );
}

export default ReturnHeader;
